export default __webpack_public_path__ + "static/media/secondstepmobile.323bfa4e.png";